import usersBanner from "@/assets/info/users-banner3.gif";

export const USERS = {
  partners: {
    nuanwa: {
      name: '暖哇',
      probability: 90,
      slots: {
        user_pops: {
          ads: {
            USER_POPS: {
              id: 'USER_POPS_ADS_A',
              imgUrl: require('@/assets/info/users-pops3.gif'),
              eventName: 'Jump-to-user-pops-nuanwa',
              content: `{"key":"点击个人中心弹窗","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2026060908',
              partners: '暖哇',
              probability: 100,
            },
          },
        },
        users_banner:{
          ads:{
            USERS_BANNER_ADS:{
              id: 'USERS_BANNER_ADS',
              imgUrl: require('@/assets/info/users-banner3.gif'),
              eventName: 'Jump-to-user-banner-nuanwa',
              content: `{"key":"点击个人中心广告","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2026060907',
              partners: '暖哇',
              probability: 50,
            },
            USERS_BANNER_ADS_B:{
              id: 'USERS_BANNER_ADS',
              imgUrl: require('@/config/assets/nuanwa/users/user_props2.png'),
              eventName: 'Jump-to-user-banner1B-nuanwa',
              content: `{"key":"点击个人中心广告","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2026060905',
              partners: '暖哇',
              probability: 50,
            },
          }
        }
      },
    },
    yixin:{
      name: '毅新',
      probability: 5,
      slots: {
        user_pops: {
          ads: {
            USER_POPS: {
              isWatch:false,
              id: 'USER_POPS_YIXIN_ADS_A',
              imgUrl: require('@/config/assets/yixin/users/user_props.png'),
              eventName: 'fund-users-pop-click-yixin',
              content: `{"key":"点击个人中心弹窗","partners":"毅新"}`,
              jumpUrl: 'https://item.jd.com/10168369141526.html?extension_id=eyJhZCI6IjI2OCIsImNoIjoiMiIsInNrdSI6IjEwMTY4MzY5MTQxNTI2IiwidHMiOiIxNzgxNTg3NTk5IiwidW5pcWlkIjoie1wiY2xpY2tfaWRcIjpcImRiN2NjNDJiLWQxYWEtNGUxZS04NzRkLWIxZDQ2MjkwOTgxNVwiLFwibWF0ZXJpYWxfaWRcIjpcIjU0NDA1MjAwMTYzXCIsXCJwb3NfaWRcIjpcIjI2OFwiLFwic2lkXCI6XCI1YzQyYTJkZC0xYzFmLTQ1NDEtYjZkNi1lNzU3M2Y1NWMwMzlcIn0ifQ==&jd_pop=db7cc42b-d1aa-4e1e-874d-b1d462909815&abt=0',
              partners: '毅新',
              probability: 100,
            },
          },
        },
        users_banner:{
          ads:{
            USERS_BANNER_ADS:{
              isWatch:false,
              id: 'USERS_BANNER_ADS',
              imgUrl: require('@/config/assets/yixin/users/users-banner.png'),
              eventName: 'Jump-to-user-banner-yixin',
              content: `{"key":"点击个人中心广告","partners":"毅新"}`,
              jumpUrl: 'https://item.jd.com/10168369141526.html?extension_id=eyJhZCI6IjI2OCIsImNoIjoiMiIsInNrdSI6IjEwMTY4MzY5MTQxNTI2IiwidHMiOiIxNzgxNTg3NTk5IiwidW5pcWlkIjoie1wiY2xpY2tfaWRcIjpcImRiN2NjNDJiLWQxYWEtNGUxZS04NzRkLWIxZDQ2MjkwOTgxNVwiLFwibWF0ZXJpYWxfaWRcIjpcIjU0NDA1MjAwMTYzXCIsXCJwb3NfaWRcIjpcIjI2OFwiLFwic2lkXCI6XCI1YzQyYTJkZC0xYzFmLTQ1NDEtYjZkNi1lNzU3M2Y1NWMwMzlcIn0ifQ==&jd_pop=db7cc42b-d1aa-4e1e-874d-b1d462909815&abt=0',
              partners: '毅新',
              probability: 100,
            },
          }
        }
      },
    },
    haohai:{
      name: '浩海',
      probability: 5,
      slots: {
        user_pops: {
          ads: {
            USER_POPS: {
              isWatch:false,
              id: 'USER_POPS_ADS_A',
              imgUrl: require('@/config/assets/haohai/users/user_props.png'),
              eventName: 'fund-user-pops-click-haohai',
              content: `{"key":"点击个人中心弹窗","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 100,
            },
          },
        },
        users_banner:{
          ads:{
            USERS_BANNER_ADS:{
              isWatch:false,
              id: 'USERS_BANNER_ADS',
              imgUrl: require('@/config/assets/haohai/users/users-banner.png'),
              eventName: 'Jump-to-user-banner-haohai',
              content: `{"key":"点击个人中心广告","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 100,
            },
          }
        }
      },
    }
  },
}

export const userPageData = [
  'Jump-to-user-banner-yixin','fund-users-pop-click-yixin',
  'Jump-to-user-banner-haohai','fund-user-pops-click-haohai'
]
